import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const certificateUpcomingExpirationTemplates = [
  {
    id: '-133001',
    language: Language.EN,
    subject: 'Certificate expiring soon',
    type: TemplateType.MAIL,
    subType: TemplateSubType.CERTIFICATE_UPCOMING_EXPIRATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{getContactName contact}},</p>
        <p></p>
        <p>This is a reminder that the certificate <b>{{certificateName}}</b> will expire on <b>{{expirationDate}}</b> (in {{remainingDays}} days) for the following properties:</p>
        {{getBuildingNames buildings}}
        <p></p>
        <p>Please take the necessary steps to renew it before the expiration date.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-133002',
    language: Language.FR,
    subject: 'Certificat bientôt expiré',
    type: TemplateType.MAIL,
    subType: TemplateSubType.CERTIFICATE_UPCOMING_EXPIRATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher {{getContactName contact}},</p>
        <p></p>
        <p>Nous vous rappelons que le certificat <b>{{certificateName}}</b> expirera le <b>{{expirationDate}}</b> (dans {{remainingDays}} jours) pour les biens suivants :</p>
        {{getBuildingNames buildings}}
        <p></p>
        <p>Veuillez prendre les mesures nécessaires pour le renouveler avant la date d'expiration.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-133003',
    language: Language.NL,
    subject: 'Certificaat verloopt binnenkort',
    type: TemplateType.MAIL,
    subType: TemplateSubType.CERTIFICATE_UPCOMING_EXPIRATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{getContactName contact}},</p>
        <p></p>
        <p>Wij herinneren u eraan dat het certificaat <b>{{certificateName}}</b> verloopt op <b>{{expirationDate}}</b> (over {{remainingDays}} dagen) voor de volgende panden:</p>
        {{getBuildingNames buildings}}
        <p></p>
        <p>Gelieve de nodige stappen te ondernemen om het vóór de vervaldatum te vernieuwen.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-133004',
    language: Language.DE,
    subject: 'Zertifikat läuft bald ab',
    type: TemplateType.MAIL,
    subType: TemplateSubType.CERTIFICATE_UPCOMING_EXPIRATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{getContactName contact}},</p>
        <p></p>
        <p>Wir möchten Sie daran erinnern, dass das Zertifikat <b>{{certificateName}}</b> am <b>{{expirationDate}}</b> abläuft (in {{remainingDays}} Tagen) für die folgenden Immobilien:</p>
        {{getBuildingNames buildings}}
        <p></p>
        <p>Bitte ergreifen Sie die notwendigen Maßnahmen, um es vor dem Ablaufdatum zu erneuern.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
